module.exports = __webpack_public_path__ + "79294cd8fabb012080155ee22ccf5280.png";